import SightGalleryContainer from './SightGalleryContainer';

export default SightGalleryContainer;
